import { State, Action, StateContext, Selector } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { LoadPermissionsSuccess } from '../actions/permissions.actions';

export interface PermissionsStateModel {
  permissions: string[];
}

@State<PermissionsStateModel>({
  name: 'permissions',
  defaults: {
    permissions: [],
  },
})
@Injectable()
export class PermissionsState {
  // Selectors
  @Selector()
  static getAllPermissions(state: PermissionsStateModel): string[] {
    return state?.permissions;
  }

  @Selector()
  static arePermissionsLoaded(state: PermissionsStateModel): boolean {
    return state?.permissions?.length > 0;
  }

  // Actions
  @Action(LoadPermissionsSuccess)
  loadPermissionsSuccess(
    ctx: StateContext<PermissionsStateModel>,
    action: LoadPermissionsSuccess
  ) {
    ctx.patchState({ permissions: action.permissions });
  }
}
